import { StyledIconButton } from "./styled";
import { IIconButtonProps } from "./types";

const IconButton = ({ children, position, variant = 'filled', color = 'primary', ...props }: IIconButtonProps) => (
    <StyledIconButton {...props} customPosition={position} customVariant={variant} customColor={color}>
        {children}
    </StyledIconButton>
)

export { IconButton }